import { useTranslation } from 'react-i18next';
import { ImageSliderLayout } from '../../image-slider-layout';

export function Introduction(props: {
  firstname: string;
  lastname: string;
  isOffer: boolean;
}) {
  const { t } = useTranslation('offer-package');

  return (
    <div className="print:hidden text-gray-700">
      <div className="w-full aspect-square md:h-160 items-center text-center">
        <ImageSliderLayout
          className="bg-brand-green-700 text-white m-0"
          link={[
            [
              {
                url: 'https://cdn.mandira-ayurveda.at/images/inquiry/hotel-entrance.webp',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2024/05/Indoor-Heilthermalpool-3-scaled.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2024/04/Yogatempel-4-scaled.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2024/06/Ayurveda-Resort-Mandira_Stirnguss-1-e1719472048640.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2025/04/Lavendelbibliothek-scaled.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2025/04/Bar1-scaled.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2025/03/Aussenpool_Abends-5-scaled.jpg',
              },
            ],
            [
              {
                url: 'https://www.mandira-ayurveda.at/wp-content/uploads/2025/04/Terasse_Bar-scaled.jpg',
              },
            ],
          ]}
          alt="Essen"
        ></ImageSliderLayout>
      </div>

      <div className="text-3xl font-serif text-brand-cashmere-900 container max-w-3xl px-2 sm:px-0 my-20">
        {props.isOffer
          ? t('introduction.offer')
          : t('introduction.reservation')}
        : {props.lastname} {props.firstname}
      </div>

      <div className="container max-w-3xl px-2 md:px-0 text-brand-cashmere-800 font-light">
        <h1 className="mb-8">{t('introduction.title')}</h1>

        <p>{t('introduction.description1')}</p>
        <p className="mt-2">{t('introduction.description2')}</p>
        <p className="mt-2">{t('introduction.description3')}</p>
      </div>
    </div>
  );
}

export default Introduction;
